import { selectBasketRentingSummary } from 'containers/OrderDetails/basketSlice'
import Schedule from 'containers/OrderDetails/Summary/Schedule'
import useTranslation from 'hooks/useTranslation'
import Skeleton from 'react-loading-skeleton'
import { displayPrice } from 'utils/string'
import { useSelector } from 'react-redux'

const SummarySection = () => {
  const rentingSummary = useSelector(selectBasketRentingSummary)
  const { t } = useTranslation('basket')
  return (
    <div>
      <div className='list__header element__title'>{t('summary')}</div>
      <div className='list__element --big'>
        <div className='element__title'>{t('costs')}</div>
        {rentingSummary?.to_pay
          ? <div className='element__desc'>
            {Number(rentingSummary?.to_pay?.installation?.grossPrice) > 0 && <div className='group'>
              <span>{t('installationFee')}:</span>
              <span className='--marked'>{displayPrice(rentingSummary.to_pay.installation.grossPrice)}</span>
            </div>}
            {Number(rentingSummary?.to_pay?.reservation?.grossPrice) > 0 && <div className='group'>
              <span>{t('reservationFee')}:</span>
              <span className='--marked'>{displayPrice(rentingSummary.to_pay.reservation.grossPrice)}</span>
            </div>}
            <div className='group'>
              <span>{t('amountToPay')}:</span>
              <span className='--marked'>{displayPrice(rentingSummary?.to_pay?.now?.grossPrice)}</span>
            </div>
          </div>
          : <div className='element__desc'>
            <Skeleton />
          </div>}
        {rentingSummary?.to_pay?.monthly && rentingSummary?.to_pay?.monthly.length > 0 && <>
          <div className='element__title'>{t('schedule')}</div>
          <Schedule schedule={rentingSummary.to_pay.monthly} />
        </>}
      </div>
    </div>
  )
}

export default SummarySection